import { Flex, Spinner } from "@folksam/ui-next/components";
import React from "react";
import PensionCalculator from "./components/PensionCalculator";
import useGetData from "./hooks/useGetData";
import ErrorPage from "./components/ErrorPage";
import { PensionCalculatorResponse } from "./types";

function App() {
  const { isLoading, data, isError, refetch } =
    useGetData<PensionCalculatorResponse>();

  if (isLoading) {
    return (
      <Flex
        sx={{ justifyContent: "center", alignItems: "center", height: "100vh" }}
      >
        <Spinner duration={700} />
      </Flex>
    );
  }

  if (isError) {
    return <ErrorPage showTryAgain onTryAgain={refetch} />;
  }

  return <PensionCalculator data={data} />;
}

export default App;
